import React, { memo, useState } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import WalletSectionCard from './WalletSectionCard';
import WalletLegalIdCard from '../wallet/WalletLegalIdCard';
import WalletLegalIdDetailModal from '../wallet/WalletLegalIdDetailModal';
import usWorkCardStyle from '../../style/components/profile/USWorkSectionCard.module.scss';

const WalletCredentials = () => {
  const { t } = useTranslation();
  const legalIds = useSelector((state) => state.countryWorkProfile.legalIds);
  const [selectedDocIndex, setSelectedDocIndex] = useState(null);

  return (
    <WalletSectionCard
      title={t('profile.credentials')}
      noDivider
      className={usWorkCardStyle.card}
    >
      <div className={usWorkCardStyle.credentialsGrid}>
        {legalIds.map((doc, index) => (
          <WalletLegalIdCard
            key={doc.kind}
            variant={doc.kind}
            onClick={() => setSelectedDocIndex(index)}
            showCardHolderName
          />
        ))}
      </div>
      {selectedDocIndex !== null && (
        <WalletLegalIdDetailModal
          documents={legalIds}
          selectedIndex={selectedDocIndex}
          isOpen
          onClose={() => setSelectedDocIndex(null)}
          onNavigate={setSelectedDocIndex}
        />
      )}
    </WalletSectionCard>
  );
};

export default memo(WalletCredentials);
